import Vue from 'vue'
import dayjs from '@/boot/dayjs.js'
export default async ({ store, app } /* { app, router, Vue ... } */) => {
    /**
     * 添加埋点
     */
    const addTrack = (type, eventData = {}) => {
        if (eventData.hasOwnProperty('timeField')) {
            const timeStr = dayjs().format('YYYY-MM-DD HH:mm:ss')
            eventData[eventData.timeField] = timeStr
            delete eventData.timeField
        }
        store
            .apiPost('addTrackIndo', {
                eventType: type,
                sourceCode: 10,
                userId: store.state.userInfo.userId,
                eventData: JSON.stringify(eventData),
            },false)
            .then(res => {})
            .catch(err => {
                console.log(err)
            })
    }

    Vue.mixin({
        methods: {
            addTrack,
        },
    })
    app.addTrack = addTrack
    return addTrack
}
